import { useState, useEffect } from "react";
import * as WorkingPartService from "../../../../services/WorkingPartService";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import { ButtonClose } from "./style";
import WorkingPartForm from "../dailyPartFormEdit";
import WorkingPartAdminForm from "../workingPartAdminForm";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";

export const useDailyPartEditDate = (refresh) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    // StopServices.getLastStop().then((result) => {
    //   setLastStop(result);
    // });
  }, []);

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  const createPart = async (isTechnical, dailyUuid) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <WorkingPartForm
                  dailyUuid={dailyUuid}
                  isTechnical={isTechnical}
                  onCancel={() => handlerClosePopup("ModalForm")}
                  onSuccess={() => {
                    handlerClosePopup("ModalForm");
                    if (refresh) {
                      refresh();
                    }
                  }}
                  // toEdit={stop}
                  // custom
                ></WorkingPartForm>
              </div>
            </div>
          </>
        ),
      })
    );
  };

  const editDailyPart = async (workingPartUuid) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <WorkingPartForm
                  uuid={workingPartUuid}
                  onCancel={() => handlerClosePopup("ModalForm")}
                  onSuccess={() => {
                    handlerClosePopup("ModalForm");
                    if (refresh) {
                      refresh();
                    }
                  }}
                  // toEdit={stop}
                  // custom
                ></WorkingPartForm>
              </div>
            </div>
          </>
        ),
      })
    );
  };

  const deletePart = async (isTechnical, workingPartUuid) => {
    const okAction = async () => {
      WorkingPartService.deleteWorkingPart(workingPartUuid).then((result) => {
        if (result && result.deleted === true) {
          if (refresh) {
            refresh();
          }
        }
      });
    };

    const cancelAction = () => {};

    ShowAlertDialog(
      t("forms.workingPart.dialog.remove.title"),
      t("forms.workingPart.dialog.remove.text"),
      "warning",
      true,
      t("forms.workingPart.dialog.remove.buttonOk"),
      false,
      okAction,
      t("forms.workingPart.dialog.remove.buttonNo"),
      cancelAction,
      "#6ec1e4"
    );
  };

  const validateDailyPart = async (workingPartUuid) => {
    try {
      const okAction = async () => {
        const result = await WorkingPartService.validateDailyWorkingPart(
          workingPartUuid
        );
        if (result) {
          if (refresh) {
            refresh();
          }
        }
      };

      const cancelAction = () => {};

      ShowAlertDialog(
        t("forms.workingPart.dialog.validate.title"),
        t("forms.workingPart.dialog.validate.text"),
        "warning",
        true,
        t("forms.workingPart.dialog.validate.buttonOk"),
        false,
        okAction,
        t("forms.workingPart.dialog.validate.buttonNo"),
        cancelAction,
        "#6ec1e4"
      );
    } catch (error) {}
  };

  const confirmDailyPart = async (workingPartUuid) => {
    try {
      const okAction = async () => {
        const result = await WorkingPartService.confirmDailyWorkingPart(
          workingPartUuid
        );
        if (result) {
          if (refresh) {
            refresh();
          }
        }
      };

      const cancelAction = () => {};

      ShowAlertDialog(
        t("forms.workingPart.dialog.confirm.title"),
        t("forms.workingPart.dialog.confirm.text"),
        "warning",
        true,
        t("forms.workingPart.dialog.confirm.buttonOk"),
        false,
        okAction,
        t("forms.workingPart.dialog.confirm.buttonNo"),
        cancelAction,
        "#6ec1e4"
      );
    } catch (error) {}
  };

  const confirmAllDailyPart = async () => {
    try {
      const okAction = async () => {
        const result = await WorkingPartService.confirmAllDailyWorkingPart();
        if (result) {
          if (refresh) {
            refresh();
          }
        }
      };

      const cancelAction = () => {};

      ShowAlertDialog(
        t("forms.workingPart.dialog.confirmAll.title"),
        t("forms.workingPart.dialog.confirmAll.text"),
        "warning",
        true,
        t("forms.workingPart.dialog.confirmAll.buttonOk"),
        false,
        okAction,
        t("forms.workingPart.dialog.confirmAll.buttonNo"),
        cancelAction,
        "#6ec1e4"
      );
    } catch (error) {}
  };

  const createAdminDailyPart = async () => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <WorkingPartAdminForm
                  // dailyUuid={dailyUuid}
                  onCancel={() => handlerClosePopup("ModalForm")}
                  onSuccess={() => {
                    handlerClosePopup("ModalForm");
                    if (refresh) {
                      refresh();
                    }
                  }}
                  // toEdit={stop}
                  // custom
                ></WorkingPartAdminForm>
              </div>
            </div>
          </>
        ),
      })
    );
  };

  return {
    createPart,
    editDailyPart,
    deletePart,
    validateDailyPart,
    confirmDailyPart,
    confirmAllDailyPart,
    createAdminDailyPart,
  };
};
